import { Box, type ChakraProps, useColorModeValue, useBreakpointValue } from '@chakra-ui/react';
import { type PropsWithChildren } from 'react';

export function Card(props: ChakraProps & PropsWithChildren) {
  const cardBackground = useColorModeValue('gray.50', 'gray.700');
  /** Height fills column on large screens; inner panels handle their own scroll (outer overflow hid footers). */
  const mediaProps = useBreakpointValue<Partial<ChakraProps>>({
    base: { height: 'unset' },
    lg: { height: 'full' },
  });
  const { children, ...rest } = props;
  return (
    <Box background={cardBackground} width='full' py={4} px={6} borderRadius={24} {...mediaProps} {...rest}>
      {children}
    </Box>
  );
}
